import { productDescriptionsApiConnector } from 'apiConnector/product-descriptions';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, mergeMap, timeoutWith } from 'rxjs/operators';
import {
  productDescriptionsFailed,
  productDescriptionsReceived,
  productDescriptionsTimeouted,
} from 'state/product-description/action';
import type { ProductDescriptionResult } from 'state/product-description/model';
import type { EpicWithThunk } from 'state/state.common';

export interface FetchProductDescriptionsEpicApi {
  getProductDescriptions(): Observable<ProductDescriptionResult>;
}

export function fetchProductDescriptionsEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('PRODUCT_DESCRIPTIONS_REQUESTED'),
      mergeMap(() => {
        return productDescriptionsApiConnector(httpClient)
          .getProductDescriptions()
          .pipe(
            map(result => productDescriptionsReceived(result)),
            catchError(_ => of(productDescriptionsFailed())),
            timeoutWith(timeoutInMillis, of(productDescriptionsTimeouted()), appScheduler),
          );
      }),
    );
}
